import axios from "axios";


import {
    Configuration,
    OperatorCalculationSettingsResponse,
    OperatorUpdateCalculationSettingsRequest,
    SettingsApi
} from "../generated/callApi";
import {Settings} from "../../../domain/settings/settings";

export class SettingsRepository {
    private service: SettingsApi;

    constructor() {
        this.service = new SettingsApi(new Configuration(), process.env.REACT_APP_BACKEND_URL)
    }

    async ReadSettings(signal?: AbortSignal): Promise<Settings | Error> {
        try {
            let response = await this.service.apiSettingsGet({ headers: { "Authorization": localStorage.getItem("token") }, signal })

            if (response.status === 200) {
                return this.toDomainSettings(response.data)
            }
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    async UpdateSettings(arg: OperatorUpdateCalculationSettingsRequest): Promise<boolean | Error> {
        try {
            let response = await this.service.apiSettingsPut(arg, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 201  || response.status === 200) {
                return true;
            }
            return false;
        } catch(e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }
            
            return Error("error authorization")
        }
        
        return Error("error authorization")
    }

    
    private toDomainSettings(settings: OperatorCalculationSettingsResponse): Settings {
        return new Settings(settings);
    }
    
}